'use client'

import { usePathname } from 'next/navigation'
import RightContent from './components/auth-right-content'

// export const metadata: Metadata = {
//   title: 'Rev Pay',
//   description: 'Generated by create next app',
// }

export default function AuthLayout({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const path = usePathname()

  return path?.startsWith('/admin/login')
    || path?.startsWith('/sign-up')
    || path?.startsWith('/admin/change-password')
    ? (
        <div className="min-h-screen w-full">{children}</div>
      )
    : (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div className="h-full w-full">{children}</div>
          <div className="hidden sm:block">
            <RightContent />
          </div>
        </div>
      )
}
